var { WrappedIdError, IdError } = require("../../../typing/typing");

var
  C = require("./Constructors"),
  Var         = C.Var,
  Application = C.Application,
  Lambda      = C.Lambda,
  External    = C.External;
var
  getExternalId = require("./Externals").getExternalId;

/**
 * Id of lambda term.
 * @member
 * @memberof module:Lambda/LambdaTermId
 */
function LambdaTermId(term) {
  if(term instanceof Var)
    return term;
  if(term instanceof Application)
    return new Application(
      LambdaTermId(term.func),
      LambdaTermId(term.arg));
  if(term instanceof Lambda)
    return new Lambda(term.arg, LambdaTermId(term.body));
  if(term instanceof External) {
    var id = getExternalId(term.objType);
    try {
      return new External(id(term.object), term.objType, term.termType);
    } catch(e) {
      throw new WrappedIdError(e,
        "external object does not match its type", term, LambdaTermId);
    }
  }
  throw new IdError("unknown term format", term, LambdaTermId);
}

LambdaTermId.typeName = "Lambda term";

module.exports = LambdaTermId;
